<template>
  <div>
    <card card-body-classes="" no-footer-line v-if="paper">
      
      <h4 slot="header" class="title title-up">
        {{ paper.code }} - 
        {{ paper.title }}
      </h4>
      <p class="card-text mb-3">This course belongs to {{ paper.deanery }} deanery. Below mentioned is the detailed contents of this course.</p>
      <div class="page" contenteditable="false" v-html="paper.description"></div>
      <div class="pdf-document" v-if="paper.pdf">
        <PDFVuer :src="paper.pdf" />
      </div>
    </card>
  </div>
</template>

<script>
import { Card, PDFVuer } from 'src/components';
import { Breadcrumb, BreadcrumbItem } from "element-ui";
import pdf from 'pdfvuer'
import { mapGetters } from 'vuex';

export default {
  name: 'PapersShowcase',
  components: {
    Card,
    pdf,
    PDFVuer,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
  },
  computed: {
    ...mapGetters({
        paper: 'getPaper',
    })
  },
  methods: {
    handleEdit(slug){
        this.$router.push(`/CBCS/papers/edit/${slug}`)
    }
  },
  mounted() {
    this.$store.dispatch('getPaper', this.$route.params.slug)
  }
};
</script>

<style lang="scss" scoped>
  .title.title-up{
    color: #555;
    small{
      margin-top: 20px;
      display: block;
      margin-bottom: -10px;
    }
  }
  .pdf-document{
    color: white;
    padding: 2% 10%;
    background: rgb(82, 86, 89)
  }
</style>
